import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  ElementRef,
  ViewChild,
  inject,
  input,
} from '@angular/core';
import * as Plotly from 'plotly.js-basic-dist-min';

@Component({
  selector: 'app-plotly-plot-modal',
  standalone: true,
  template: `
    <div #container class="plot-container"></div>
  `,
  styles: [
    `
      :host {
        display: block;
        width: 100%;
        height: 100%;
      }

      .plot-container {
        width: 100%;
        height: 100%;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlotlyPlotModalComponent implements AfterViewInit {
  readonly data = input.required<any[]>();
  readonly layout = input.required<any>();
  readonly config = input.required<any>();

  @ViewChild('container', { static: true })
  container!: ElementRef<HTMLDivElement>;

  private destroyRef = inject(DestroyRef);
  private resizeObserver!: ResizeObserver;
  private plotEl!: HTMLDivElement;

  ngAfterViewInit() {
    this.plotEl = this.container.nativeElement;

    this.waitForSizeAndRender();
  }

  private waitForSizeAndRender() {
    const el = this.plotEl;

    const checkSize = () => {
      const rect = el.getBoundingClientRect();

      if (rect.width > 0 && rect.height > 0) {
        this.initializePlot();
      } else {
        requestAnimationFrame(checkSize);
      }
    };

    checkSize();
  }

  private async initializePlot() {
    await Plotly.newPlot(
      this.plotEl,
      this.data(),
      { ...this.layout(), autosize: true },
      { ...this.config(), responsive: true }
    );

    // 🔥 FORCE ONE SAFE RESIZE
    Plotly.Plots.resize(this.plotEl);

    // 🔥 Observe further changes
    this.resizeObserver = new ResizeObserver(() => {
      Plotly.Plots.resize(this.plotEl);
    });

    this.resizeObserver.observe(this.plotEl);

    this.destroyRef.onDestroy(() => {
      this.resizeObserver?.disconnect();
      Plotly.purge(this.plotEl);
    });
  }
}
